import { customerMarketShopfrontJobsApi } from '@envato/foundation-types'
import { IPageBlock } from '../../typings/pageBlocks'
import { IState } from '../reducers/homePage'

function updateItemsForBlocks(
  blocks: IPageBlock[],
  data: customerMarketShopfrontJobsApi.IItem[]
) {
  return blocks.map((block: IPageBlock) => ({
    ...block,
    ...(block.componentType === 'NewestItemsBlock'
      ? {
          data
        }
      : {})
  }))
}

export function updateNewestItemsBlock(
  state: IState,
  items: customerMarketShopfrontJobsApi.IBaseResult
) {
  const { blocks, blocksB, blocksC, blocksD } = state
  const { matches } = items

  return {
    blocks: updateItemsForBlocks(blocks, matches),
    blocksB: updateItemsForBlocks(blocksB, matches),
    blocksC: updateItemsForBlocks(blocksC, matches),
    blocksD: updateItemsForBlocks(blocksD, matches)
  }
}
